import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from 'react-aria-components';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { Grid } from '@pages/admin/article-list/grid/Grid';



export const ArticleList = () => {
	const { t } = useTranslation('admin');
	const navigate = useNavigate();

	return (
		<div className="app-page admin-page article-list-page">
			
			<h1>{t('pages.articleList.header')}</h1>
			
			<Grid />

			<div className='new-article-button'>
				<Button
					className='app-admin-button disable-selection'
					onPress={() => navigate(NavigateRoutesEnum.article)}>
					{t('pages.articleList.newButton')}
				</Button>
			</div>

		</div>
	);
};